export default __webpack_public_path__ + "static/media/retirement.93fc5f72.JPG";